export default __webpack_public_path__ + "static/media/SubtractTop.6821afb8.svg";